import { clearClaimToken, clearShopifyReturnShop, queryClient, sseManager, storage } from '@discovr/common';
import { clearAllShopifyDrafts } from '@discovr/features/shopify';
import { useBrandDraftsStore } from '@/dashboard/campaign-detail/hooks/useBrandDraftsStore';

/** Everything the brand app must not carry from one login to the next in the same tab. */
export function onBrandSignOut() {
  try {
    // sessionStorage is scoped to the tab, not the user — an unclaimed token
    // would otherwise still be here for whoever signs in next.
    clearClaimToken();
    clearShopifyReturnShop();
    storage.remove('discovr_brand_new_campaign_draft_v2');
    // The Competitors bell's notes (packages/ui competitors/chrome.tsx, `comp.notes:<brand>:<uid>`)
    // are per user; the page is a lazy chunk, so the keys are swept here by prefix.
    Object.keys(localStorage)
      .filter((k) => k.startsWith('comp.notes'))
      .forEach((k) => localStorage.removeItem(k));
    sseManager.disconnect();
  } catch {
    /* ignore */
  }
  try {
    useBrandDraftsStore.persist.clearStorage();
  } catch {
    /* ignore */
  }
  try {
    // Cached query data — attachment blobs included — belongs to the user who just left (admin does the same).
    queryClient.clear();
  } catch {
    /* ignore */
  }
  // Unsaved Shopify coupon-settings drafts are explicitly NOT meant to
  // survive a logout/login (even for the same user) — they were never saved.
  clearAllShopifyDrafts();
}
